<template>
  <div class="withdraw-audit">
    <el-card shadow="never">
      <div class="search-area">
        <el-form :inline="true" :model="query" class="search-form" @submit.native.prevent>
          <el-form-item label="关键字">
            <el-input
              v-model="query.keyword"
              maxlength="50"
              show-word-limit
              clearable
              placeholder="请输入用户名、手机号"
              style="width: 260px"
              @keyup.enter.native="onSearch"
            />
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="query.status" placeholder="全部" clearable style="width: 160px">
              <el-option label="全部" value="" />
              <el-option label="待审核" value="PENDING" />
              <el-option label="已通过" value="APPROVED" />
              <el-option label="已驳回" value="REJECTED" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否打款">
            <el-select v-model="query.paidStatus" placeholder="请选择" style="width: 160px">
              <el-option label="未打款" value="UNPAID" />
              <el-option label="已打款" value="PAID" />
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="query.applyRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              clearable
              style="width: 380px"
            />
          </el-form-item>
          <el-form-item label="审核时间">
            <el-date-picker
              v-model="query.reviewRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              clearable
              style="width: 380px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="btn-group">
          <img
            class="toolbar-back-icon"
            src="@/static/iconImage/reback-icon-64.png"
            alt="返回首页"
            title="返回首页"
            @click="onBackDashboard"
          />
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="list-card">
      <el-table :data="list" border stripe style="width: 100%">
        <el-table-column prop="createdAt" label="申请时间" min-width="160" />
        <el-table-column prop="staffName" label="会员" min-width="120" show-overflow-tooltip />
        <el-table-column prop="staffPhone" label="手机号" min-width="120" />
        <el-table-column prop="totalAmount" label="金额（元）" width="110" align="right" />
        <el-table-column label="审核状态" width="100">
          <template slot-scope="scope">
            <span :class="statusTextClass(scope.row.status)">{{ statusLabel(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewedAt" label="审核时间" min-width="160" />
        <el-table-column prop="rejectReason" label="驳回原因" min-width="160" show-overflow-tooltip />
        <el-table-column label="是否打款" width="100">
          <template slot-scope="scope">
            <span :class="paidTextClass(scope.row.paidStatus)">{{ paidStatusLabel(scope.row.paidStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="paidAt" label="打款日期" min-width="160" />
        <el-table-column label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <el-popover placement="top" trigger="click" width="320">
              <div class="account-popover">
                <div class="account-popover__line">
                  持卡人姓名：{{ scope.row.bankCardHolder || '-' }}
                </div>
                <div class="account-popover__line">
                  银行卡号：{{ scope.row.bankCardNoPlain || scope.row.bankCardNoMask || '-' }}
                </div>
                <div class="account-popover__line">
                  开户银行：{{ scope.row.bankName || '-' }}
                </div>
              </div>
              <el-button slot="reference" type="text" size="small">提现账户</el-button>
            </el-popover>
            <template v-if="normalizeStatus(scope.row.status) === 'PENDING'">
              <el-button type="text" size="small" @click="onApprove(scope.row)">通过</el-button>
              <el-button type="text" size="small" @click="onOpenReject(scope.row)">不通过</el-button>
            </template>
            <template v-else-if="normalizeStatus(scope.row.status) === 'APPROVED'">
              <el-button
                class="btn-mark-paid"
                type="text"
                size="small"
                :disabled="normalizePaidStatus(scope.row.paidStatus) === 'PAID'"
                @click="onMarkPaid(scope.row)"
              >
                已打款
              </el-button>
            </template>
            <span v-else class="op-muted">—</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="pagination-wrapper">
      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="query.pageSize"
        :current-page.sync="query.page"
        :page-sizes="[10, 20, 50]"
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
      />
    </div>

    <el-dialog title="不通过原因" :visible.sync="rejectDialogVisible" width="520px">
      <el-input
        type="textarea"
        v-model="rejectReason"
        :rows="5"
        maxlength="200"
        show-word-limit
        placeholder="请填写不通过原因（必填，最多200字）"
      />
      <span slot="footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onRejectSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/services/api';

const MAX_RANGE_MS = 365 * 86400000;

function pad2(n) {
  return String(n).padStart(2, '0');
}

function formatDateTime(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(
    d.getMinutes()
  )}:${pad2(d.getSeconds())}`;
}

/** 申请时间默认：当天 00:00:00 ~ 23:59:59 */
function buildDefaultApplyRange() {
  const d = new Date();
  const y = d.getFullYear();
  const m = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());
  return [`${y}-${m}-${day} 00:00:00`, `${y}-${m}-${day} 23:59:59`];
}

/** 审核时间默认：近 30 天至当前时刻 */
function buildDefaultReviewRange() {
  const end = new Date();
  const start = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 0, 0, 0);
  start.setDate(start.getDate() - 30);
  return [formatDateTime(start), formatDateTime(end)];
}

export default {
  name: 'WithdrawAudit',
  data() {
    return {
      list: [],
      total: 0,
      query: {
        status: 'PENDING',
        paidStatus: 'UNPAID',
        page: 1,
        pageSize: 10,
        applyRange: [],
        reviewRange: [],
        keyword: ''
      },
      rejectDialogVisible: false,
      rejectReason: '',
      currentRejectRow: null
    };
  },
  created() {
    this.query.applyRange = buildDefaultApplyRange();
    this.query.reviewRange = buildDefaultReviewRange();
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    normalizeStatus(s) {
      return String(s || '').trim().toUpperCase();
    },
    normalizePaidStatus(s) {
      return String(s || '').trim().toUpperCase();
    },
    statusLabel(s) {
      const u = this.normalizeStatus(s);
      if (u === 'PENDING') return '待审核';
      if (u === 'APPROVED') return '已通过';
      if (u === 'REJECTED') return '已驳回';
      return s || '-';
    },
    statusTextClass(s) {
      const u = this.normalizeStatus(s);
      if (u === 'APPROVED') return 'status-text status-text--approved';
      if (u === 'REJECTED') return 'status-text status-text--rejected';
      return 'status-text';
    },
    paidStatusLabel(s) {
      const u = this.normalizePaidStatus(s);
      if (u === 'PAID') return '已打款';
      return '未打款';
    },
    paidTextClass(s) {
      const u = this.normalizePaidStatus(s);
      if (u === 'PAID') return 'paid-text paid-text--paid';
      return 'paid-text paid-text--unpaid';
    },
    validateDatetimeRange(range, label) {
      if (!Array.isArray(range) || range.length !== 2 || !range[0] || !range[1]) {
        return true;
      }
      const t0 = new Date(String(range[0]).replace(/-/g, '/')).getTime();
      const t1 = new Date(String(range[1]).replace(/-/g, '/')).getTime();
      if (Number.isNaN(t0) || Number.isNaN(t1)) {
        this.$message.error(`${label}时间格式不正确`);
        return false;
      }
      if (t1 < t0) {
        this.$message.error(`${label}结束时间不能早于开始时间`);
        return false;
      }
      if (t1 - t0 > MAX_RANGE_MS) {
        this.$message.error(`${label}时间范围不能超过365天`);
        return false;
      }
      return true;
    },
    buildListPayload() {
      const q = this.query;
      const body = {
        status: q.status != null ? q.status : '',
        paidStatus: q.paidStatus != null ? q.paidStatus : 'UNPAID',
        page: q.page,
        pageSize: q.pageSize,
        keyword: String(q.keyword || '')
          .trim()
          .slice(0, 50)
      };
      if (Array.isArray(q.applyRange) && q.applyRange.length === 2 && q.applyRange[0] && q.applyRange[1]) {
        body.createdAtStart = q.applyRange[0];
        body.createdAtEnd = q.applyRange[1];
      }
      /** 待审核无审核时间，传审核范围会误筛掉全部记录 */
      const st = this.normalizeStatus(q.status);
      if (
        st !== 'PENDING' &&
        Array.isArray(q.reviewRange) &&
        q.reviewRange.length === 2 &&
        q.reviewRange[0] &&
        q.reviewRange[1]
      ) {
        body.reviewedAtStart = q.reviewRange[0];
        body.reviewedAtEnd = q.reviewRange[1];
      }
      return body;
    },
    onBackDashboard() {
      this.$router.push({ name: 'Dashboard' });
    },
    onReset() {
      this.query.status = 'PENDING';
      this.query.paidStatus = 'UNPAID';
      this.query.page = 1;
      this.query.keyword = '';
      this.query.applyRange = buildDefaultApplyRange();
      this.query.reviewRange = buildDefaultReviewRange();
      this.onSearch();
    },
    async onSearch() {
      if (!this.validateDatetimeRange(this.query.applyRange, '申请')) return;
      if (!this.validateDatetimeRange(this.query.reviewRange, '审核')) return;
      try {
        const res = await api.post('/staff/withdrawal/review/list', this.buildListPayload());
        const data = (res && res.data && res.data.data) || {};
        this.list = Array.isArray(data.list) ? data.list : [];
        this.total = Number(data.total || 0);
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '加载列表失败';
        this.$message.error(msg);
      }
    },
    onPageSizeChange(size) {
      this.query.pageSize = size;
      this.query.page = 1;
      this.onSearch();
    },
    onPageChange(page) {
      this.query.page = page;
      this.onSearch();
    },
    async onApprove(row) {
      try {
        await api.post('/staff/withdrawal/review/decide', {
          withdrawalId: row.id,
          decision: 'APPROVED'
        });
        this.$message.success('审核已通过');
        this.onSearch();
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '操作失败';
        this.$message.error(msg);
      }
    },
    onOpenReject(row) {
      this.currentRejectRow = row;
      this.rejectReason = '';
      this.rejectDialogVisible = true;
    },
    async onRejectSubmit() {
      const reason = String(this.rejectReason || '').trim();
      if (!reason) {
        this.$message.warning('请填写不通过原因');
        return;
      }
      if (reason.length > 200) {
        this.$message.warning('不通过原因最多200字');
        return;
      }
      if (!this.currentRejectRow) return;
      try {
        await api.post('/staff/withdrawal/review/decide', {
          withdrawalId: this.currentRejectRow.id,
          decision: 'REJECTED',
          rejectReason: reason
        });
        this.$message.success('已驳回');
        this.rejectDialogVisible = false;
        this.onSearch();
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '操作失败';
        this.$message.error(msg);
      }
    },
    async onMarkPaid(row) {
      try {
        await this.$confirm('确认已完成打款？', '提示', { type: 'warning' });
      } catch {
        return;
      }
      try {
        await api.post('/staff/withdrawal/review/mark-paid', { withdrawalId: row.id });
        this.$message.success('已标记为已打款');
        this.onSearch();
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '操作失败';
        this.$message.error(msg);
      }
    }
  }
};
</script>

<style scoped>
.withdraw-audit {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding-bottom: 56px;
}

.search-area {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
}

.search-form {
  flex: 1;
  min-width: 0;
}

.search-form >>> .el-form-item {
  margin-bottom: 12px;
}

.btn-group {
  flex-shrink: 0;
}

.toolbar-back-icon {
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: block;
}

.list-card {
  margin-top: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-card >>> .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}

.list-card >>> .el-table {
  flex: 1;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.op-muted {
  color: #c0c4cc;
  font-size: 13px;
}

.status-text {
  font-weight: 600;
}

.status-text--approved {
  color: #67c23a;
}

.status-text--rejected {
  color: #e6a23c;
}

.paid-text {
  font-weight: 600;
}

.paid-text--unpaid {
  color: #f56c6c;
}

.paid-text--paid {
  color: #67c23a;
}

.account-popover__line {
  font-size: 13px;
  color: #606266;
  line-height: 1.7;
  word-break: break-all;
}

.btn-mark-paid {
  margin-left: 10px;
}
</style>
